import { render, staticRenderFns } from "./createAviso.vue?vue&type=template&id=375ee238&scoped=true&"
import script from "./createAviso.vue?vue&type=script&lang=js&"
export * from "./createAviso.vue?vue&type=script&lang=js&"
import style0 from "./createAviso.vue?vue&type=style&index=0&id=375ee238&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375ee238",
  null
  
)

export default component.exports